import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import currentLang from '../../js/lib/currentLang';

const scheduleElement = document.querySelectorAll('.schedule');

if (scheduleElement.length !== 0) {
	// Use different URL for Static/MVC
	for (var x = 0; x < scheduleElement.length; x++) {
		const id = scheduleElement[x].id;
		const remIdentifier = /^events_/;
		const url = envVar({
			backendPath: `/EventFeaturedListings/index/${id.replace(remIdentifier, '')}?lang=${currentLang()}`, // pass the id to us
			staticPath: `js/data/events.json?${id.replace(remIdentifier, '')}`
		});
		request().get(url).then(function(response) {
			// Vue Component
			const events = new Vue({
				el: '#' + id,
				data: {
					eventCategories: [],
					eventsList: '',
					selectedCategory: '',
				},
				// When Component is Mounted, run Methods
				mounted: function() {
					const self = this;
					self.loadEventCategories();
					if(self.eventCategories.length > 0)
					{
						self.loadEventsList(0);
						self.selectedCategory = self.eventCategories[0];
					}
				},
				// Methods
				methods: {
					loadEventCategories: function() {
						const self = this;
						self.eventCategories = response;
					},
					loadEventsList: function(index, event) {
						const self = this;
						self.eventsList = self.eventCategories[index].content;
						// if (event) means if clicked!
						if (event) {
							// removes selected link style
							for (var i = 0; i < self.$refs.eventLink.length; i++) {
								self.$refs.eventLink[i].removeAttribute('selected');
							}
							// Add selected to clicked el
							event.currentTarget.setAttribute('selected', true);
							self.selectedCategory = self.eventCategories[index];
						}
						// if forced
						else {
							// This is weird, but even if the component is mounted,
							// wait for Next Tick, this has tripped me more than once :/
							Vue.nextTick(function() {
								self.$refs.eventLink[index].setAttribute('selected', true);
							});
						}
					},
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ../components/events/eventsTabs.js